import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loadable from 'components/Loadable';
import AdminLayout from 'layout/AdminLayout';
import { AdminSessionProvider } from 'pages/admin/AdminSession';

const AdminLogin = Loadable(lazy(() => import('pages/admin/AdminLogin')));
const AdminDashboard = Loadable(lazy(() => import('pages/admin/AdminDashboard')));
const AdminTenant = Loadable(lazy(() => import('pages/admin/AdminTenant')));
const AdminTenants = Loadable(lazy(() => import('pages/admin/AdminTenants')));
const AdminStores = Loadable(lazy(() => import('pages/admin/AdminStores')));
const AdminUsers = Loadable(lazy(() => import('pages/admin/AdminUsers')));
const AdminProfile = Loadable(lazy(() => import('pages/admin/AdminProfile')));

const AdminRoot = () => (
    <AdminSessionProvider>
        <Outlet />
    </AdminSessionProvider>
);

/** Painel do dono da plataforma. Tem sessão própria e não usa o DashboardLayout das lojas. */
const AdminRoutes = {
    path: '/admin',
    element: <AdminRoot />,
    children: [
        {
            path: 'login',
            element: <AdminLogin />
        },
        {
            element: <AdminLayout />,
            children: [
                {
                    index: true,
                    element: <AdminDashboard />
                },
                {
                    path: 'tenants',
                    element: <AdminTenants />
                },
                {
                    path: 'tenants/:tenantId',
                    element: <AdminTenant />
                },
                {
                    path: 'stores',
                    element: <AdminStores />
                },
                {
                    path: 'users',
                    element: <AdminUsers />
                },
                {
                    path: 'profile',
                    element: <AdminProfile />
                },
                {
                    path: '*',
                    element: <Navigate to="/admin" replace />
                }
            ]
        }
    ]
};

export default AdminRoutes;
